import { type InjectionKey } from 'vue';

import { LoginTypeEnum } from './enums';

export const ChangeLoginTypeKey: InjectionKey<(loginType: LoginTypeEnum) => void> = Symbol('ChangeLoginType');
